export enum FontUnits {
  Pixels = 'px',
  Points = 'pt'
}
